import React from 'react';
import { Modal, Rating } from 'fronton-react';
import { EffectFade } from 'swiper/modules';
import { createElementKey } from 'utils';
import { getImageSrc } from '../../../picture';
import { Thumbs, Swiper, SwiperClass, SwiperSlide } from '../../../swiper';
import { Typography } from '../../../typography';
import {
  reviewsCatalogItemAddWrapper,
  reviewsCatalogModal,
  reviewsCatalogModalContent,
  reviewsCatalogImageBig,
  reviewsCatalogSlideThumb,
  reviewsCatalogImageSwiperBig,
  reviewsCatalogImageSwiperSmall,
  reviewsCatalogImageThumb,
  reviewsCatalogModalText,
  reviewsCatalogModalRatingWrapper,
  reviewsCatalogModalTextWrapper,
  reviewsCatalogModalRatingText,
  reviewsCatalogModalAddDataWrapper,
} from './review-catalog-modal-styles';

export type ReviewStructure = {
  imagesAlt: string;
  images: string[];
  bigImages: string[];
  rating: number;
  text: string;
  date: string;
  store?: string;
};

export const REVIEWS_PER_PAGE = 6;

type ReviewsCatalogModalProps = {
  activeReview: ReviewStructure;
  isOpen: boolean;
  onClose: () => void;
  setThumbsSwiper: (thumbSwiper: SwiperClass | null) => void;
  thumbsSwiper: SwiperClass | null;
}

export const ReviewsCatalogModal: React.FC<ReviewsCatalogModalProps> = ({
  activeReview, isOpen, onClose, setThumbsSwiper, thumbsSwiper,
}) => (
  <Modal className={reviewsCatalogModal} onClose={onClose} show={isOpen}>
    <div className={reviewsCatalogModalContent}>
      <div>
        <Swiper
          className={reviewsCatalogImageSwiperBig}
          modules={[EffectFade, Thumbs]}
          thumbs={{ swiper: thumbsSwiper }}
          effect="fade">
          {activeReview.bigImages.map((image, index) => (
            <SwiperSlide key={createElementKey('review-modal-photo', index)}>
              <img
                className={reviewsCatalogImageBig}
                alt={activeReview.imagesAlt}
                src={getImageSrc(image)}
                width="700"
                height="440"
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <Swiper
          className={reviewsCatalogImageSwiperSmall}
          modules={[Thumbs]}
          onSwiper={setThumbsSwiper}
          slidesPerView="auto"
          watchOverflow
        >
          {activeReview.bigImages.map((image, index) => (
            <SwiperSlide
              className={reviewsCatalogSlideThumb}
              key={createElementKey('review-modal-thumb-photo', index)}>
              <img
                className={reviewsCatalogImageThumb}
                alt={activeReview.imagesAlt}
                src={getImageSrc(image, { width: 32, height: 32, objectFit: 'fill' }, true)}
                width="32"
                height="32"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className={reviewsCatalogModalTextWrapper}>
        <div className={reviewsCatalogModalAddDataWrapper}>
          <div className={reviewsCatalogModalRatingWrapper}>
            <Rating value={activeReview.rating} size="l" />
            <Typography
              className={reviewsCatalogModalRatingText}
              variant="caption"
              color="success-primary">
              Рекомендую
            </Typography>
          </div>
          <div className={reviewsCatalogItemAddWrapper}>
            <Typography variant="caption" color="text-minor">
              {activeReview.date}
            </Typography>
            {activeReview.store && (
              <Typography variant="caption" color="text-minor">
                {activeReview.store}
              </Typography>
            )}
          </div>
        </div>
        <Typography className={reviewsCatalogModalText} variant="l" size="body_long">
          {activeReview.text}
        </Typography>
      </div>
    </div>
  </Modal>
);
